// Legal documents (KVKK Aydınlatma Metni & Çerez Politikası) — TR & EN.
import { company } from "@/data/site";

const controller = {
  tr: `${company.legal} ("KYT Yapı Teknolojileri" / "Şirket")`,
  en: `${company.legal} ("KYT Yapı Teknolojileri" / the "Company")`,
};

export const legalDocs = {
  kvkk: {
    slug: "kvkk",
    tr: {
      title: "KVKK Aydınlatma Metni",
      updated: "Son güncelleme: Haziran 2026",
      intro: `6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, veri sorumlusu sıfatıyla ${controller.tr} tarafından kişisel verilerinizin işlenmesine ilişkin olarak sizleri bilgilendirmek isteriz.`,
      sections: [
        {
          h: "1. Veri Sorumlusu",
          p: [
            `Kişisel verileriniz, veri sorumlusu olarak ${company.legal} tarafından aşağıda açıklanan kapsamda işlenmektedir.`,
            `Adres: ${company.address}`,
            `Telefon: ${company.phone} · E-posta: ${company.email}`,
          ],
        },
        {
          h: "2. İşlenen Kişisel Veriler ve Toplama Yöntemi",
          p: [
            "İnternet sitemizdeki iletişim formunu doldurmanız veya bizimle e-posta ya da telefon yoluyla iletişime geçmeniz halinde; ad-soyad, telefon numarası, e-posta adresi ve mesajınızda paylaştığınız bilgiler işlenebilir.",
            "Bu veriler, tarafınızca doğrudan ve açık biçimde paylaşılması yoluyla, elektronik ortamda toplanır. Sitemiz statik olup, ziyaretçi davranışlarını takip eden analitik veya pazarlama amaçlı çerez kullanılmamaktadır.",
          ],
        },
        {
          h: "3. Kişisel Verilerin İşlenme Amaçları",
          list: [
            "İletişim ve teklif taleplerinizin değerlendirilmesi ve yanıtlanması",
            "Sunduğumuz hizmetler hakkında bilgilendirme yapılması",
            "Sözleşme öncesi görüşmelerin ve iş ilişkisinin yürütülmesi",
            "Hukuki yükümlülüklerimizin yerine getirilmesi",
          ],
        },
        {
          h: "4. İşlemenin Hukuki Sebebi",
          p: [
            "Kişisel verileriniz; KVKK m.5/2-(c) bir sözleşmenin kurulması veya ifasıyla doğrudan ilgili olması, m.5/2-(ç) hukuki yükümlülüğün yerine getirilmesi ve m.5/2-(f) veri sorumlusunun meşru menfaatleri hukuki sebeplerine dayanılarak işlenmektedir. Bu sebeplerin bulunmadığı hallerde açık rızanıza istinaden işlenir.",
          ],
        },
        {
          h: "5. Kişisel Verilerin Aktarılması",
          p: [
            "Kişisel verileriniz, kural olarak üçüncü kişilerle paylaşılmamakta ve yurt dışına aktarılmamaktadır. Yalnızca yasal bir zorunluluk halinde, yetkili kamu kurum ve kuruluşlarıyla mevzuat çerçevesinde paylaşılabilir.",
          ],
        },
        {
          h: "6. Saklama Süresi",
          p: [
            "Kişisel verileriniz, işleme amacının gerektirdiği süre boyunca ve ilgili mevzuatta öngörülen zamanaşımı süreleri kadar saklanır; sürenin sona ermesinin ardından silinir, yok edilir veya anonim hale getirilir.",
          ],
        },
        {
          h: "7. İlgili Kişi Olarak Haklarınız (KVKK m.11)",
          list: [
            "Kişisel verilerinizin işlenip işlenmediğini öğrenme",
            "İşlenmişse buna ilişkin bilgi talep etme",
            "İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme",
            "Eksik veya yanlış işlenmişse düzeltilmesini isteme",
            "KVKK'da öngörülen şartlarla silinmesini veya yok edilmesini isteme",
            "İşlemenin münhasıran otomatik sistemlerle analiziyle aleyhinize bir sonuç çıkmasına itiraz etme",
            "Kanuna aykırı işleme nedeniyle zarara uğramanız halinde zararın giderilmesini talep etme",
          ],
        },
        {
          h: "8. Başvuru",
          p: [
            `Yukarıdaki haklarınıza ilişkin taleplerinizi ${company.email} e-posta adresi üzerinden veya ${company.address} adresine yazılı olarak iletebilirsiniz. Talebiniz, niteliğine göre en kısa sürede ve en geç otuz gün içinde sonuçlandırılır.`,
          ],
        },
      ],
    },
    en: {
      title: "Privacy Notice (KVKK)",
      updated: "Last updated: June 2026",
      intro: `In accordance with Turkish Personal Data Protection Law No. 6698 ("KVKK"), ${controller.en}, acting as the data controller, would like to inform you about the processing of your personal data.`,
      sections: [
        {
          h: "1. Data Controller",
          p: [
            `Your personal data is processed by ${company.legal} as the data controller within the scope explained below.`,
            `Address: ${company.address}`,
            `Phone: ${company.phone} · Email: ${company.email}`,
          ],
        },
        {
          h: "2. Personal Data Processed and Collection Method",
          p: [
            "If you fill in the contact form on our website or contact us by email or phone, your name, phone number, email address and the information you share in your message may be processed.",
            "This data is collected electronically, directly and explicitly provided by you. Our website is static and does not use any analytics or marketing cookies that track visitor behavior.",
          ],
        },
        {
          h: "3. Purposes of Processing",
          list: [
            "Evaluating and responding to your contact and quote requests",
            "Providing information about the services we offer",
            "Conducting pre-contractual discussions and the business relationship",
            "Fulfilling our legal obligations",
          ],
        },
        {
          h: "4. Legal Basis for Processing",
          p: [
            "Your personal data is processed based on the legal grounds set out in KVKK art. 5/2-(c) being directly related to the conclusion or performance of a contract, art. 5/2-(ç) compliance with a legal obligation, and art. 5/2-(f) the legitimate interests of the data controller. Where these grounds do not apply, processing is based on your explicit consent.",
          ],
        },
        {
          h: "5. Transfer of Personal Data",
          p: [
            "As a rule, your personal data is not shared with third parties and is not transferred abroad. It may only be shared with authorized public institutions within the framework of legislation in case of a legal obligation.",
          ],
        },
        {
          h: "6. Retention Period",
          p: [
            "Your personal data is retained for as long as required by the purpose of processing and the statutory periods stipulated in the relevant legislation; once the period expires, it is deleted, destroyed or anonymized.",
          ],
        },
        {
          h: "7. Your Rights as a Data Subject (KVKK art. 11)",
          list: [
            "To learn whether your personal data is processed",
            "To request information if it has been processed",
            "To learn the purpose of processing and whether it is used accordingly",
            "To request correction if processed incompletely or incorrectly",
            "To request deletion or destruction under the conditions set out in KVKK",
            "To object to a result against you arising solely from automated analysis",
            "To claim compensation if you suffer damage due to unlawful processing",
          ],
        },
        {
          h: "8. Application",
          p: [
            `You can submit your requests regarding the rights above via ${company.email} or in writing to ${company.address}. Your request will be concluded as soon as possible and within thirty days at the latest, depending on its nature.`,
          ],
        },
      ],
    },
  },

  cerez: {
    slug: "cerez-politikasi",
    tr: {
      title: "Çerez Politikası",
      updated: "Son güncelleme: Haziran 2026",
      intro:
        "Bu Çerez Politikası, internet sitemizde hangi çerezlerin ve benzer teknolojilerin kullanıldığını ve bunları nasıl yönetebileceğinizi açıklar.",
      sections: [
        {
          h: "1. Çerez Nedir?",
          p: [
            "Çerez (cookie), bir web sitesini ziyaret ettiğinizde tarayıcınıza kaydedilen küçük metin dosyalarıdır. Benzer şekilde, tarayıcınızın yerel depolama (localStorage) alanı da bazı tercihlerin saklanması için kullanılabilir.",
          ],
        },
        {
          h: "2. Kullandığımız Çerezler",
          p: [
            "Sitemiz statik bir tanıtım sitesidir ve analitik, reklam veya profilleme amaçlı çerez KULLANMAZ. Yalnızca sitenin çalışması için gerekli, zorunlu nitelikteki yerel depolama kayıtları kullanılır:",
          ],
          list: [
            "kyt_lang — seçtiğiniz dil tercihini (TR/EN) hatırlar.",
            "kyt_cookie_consent — çerez bilgilendirmesini gördüğünüzü hatırlar, böylece banner tekrar gösterilmez.",
          ],
        },
        {
          h: "3. Üçüncü Taraf İçerikler",
          p: [
            "İletişim sayfamızda konumumuzu görseldeki harita ile gösteririz; bu görsel kendi sunucumuzda barındırılır ve harici bir servise otomatik istek göndermez. Yalnızca 'Yol Tarifi Al' bağlantısına tıklamanız halinde Google Haritalar yeni bir sekmede açılır; bu durumda Google'ın kendi gizlilik ve çerez politikaları geçerli olur.",
          ],
        },
        {
          h: "4. Çerezleri Yönetme",
          p: [
            "Tarayıcınızın ayarları üzerinden çerezleri ve yerel depolama kayıtlarını dilediğiniz zaman silebilir veya engelleyebilirsiniz. Zorunlu kayıtların silinmesi durumunda dil tercihiniz sıfırlanabilir; bunun dışında sitenin işlevselliği etkilenmez.",
          ],
        },
      ],
    },
    en: {
      title: "Cookie Policy",
      updated: "Last updated: June 2026",
      intro:
        "This Cookie Policy explains which cookies and similar technologies are used on our website and how you can manage them.",
      sections: [
        {
          h: "1. What is a Cookie?",
          p: [
            "A cookie is a small text file stored in your browser when you visit a website. Similarly, your browser's local storage may be used to keep certain preferences.",
          ],
        },
        {
          h: "2. Cookies We Use",
          p: [
            "Our website is a static showcase site and does NOT use any analytics, advertising or profiling cookies. Only strictly necessary local storage entries required for the site to function are used:",
          ],
          list: [
            "kyt_lang — remembers your selected language preference (TR/EN).",
            "kyt_cookie_consent — remembers that you have seen the cookie notice so the banner is not shown again.",
          ],
        },
        {
          h: "3. Third-Party Content",
          p: [
            "On our contact page we show our location with a map image; this image is hosted on our own server and does not automatically send requests to any external service. Only if you click the 'Get Directions' link does Google Maps open in a new tab, in which case Google's own privacy and cookie policies apply.",
          ],
        },
        {
          h: "4. Managing Cookies",
          p: [
            "You can delete or block cookies and local storage entries at any time through your browser settings. If the necessary entries are deleted, your language preference may be reset; otherwise the functionality of the site is not affected.",
          ],
        },
      ],
    },
  },
};
